import {
    buildSearchQuery,
    CatalogSearchQuery,
    defaultQuery,
} from "modules/PsyCatalog/common/searchQuery"
import { CATALOG_PATH, getSubRoutes } from "modules/PsyCatalog/common/utils"
import { isBrowser } from "utils/infrastructure/ssg-utils"

export interface CurrentQuery {
    get(): CatalogSearchQuery
    getPriceRange(): [number, number]
    getAgeRange(): [number, number]
}

export const CurrentQuery: CurrentQuery = {
    getAgeRange(): [number, number] {
        const { age_from, age_to } = CurrentQuery.get()
        return [age_from, age_to]
    },
    getPriceRange(): [number, number] {
        const { price_from, price_to } = CurrentQuery.get()
        return [price_from, price_to]
    },
    get(): CatalogSearchQuery {
        if (!isBrowser()) return defaultQuery
        const fromSearch = buildSearchQuery(window.location.search)
        fromSearch.form_of_work =
            getSubRoutes(location.pathname).routes.path === CATALOG_PATH.online
                ? "online"
                : fromSearch.form_of_work
        return fromSearch
    },
}
